import { createStore, combineReducers } from 'redux'
import { configure } from '../api'
import { Provider } from 'react-redux'
import { IntlProvider } from 'react-intl'
import {
  selectedCurrency,
  setCurrency,
  pageLoader,
  itineraryPopupOpen,
  itineraryPopupData,
  resortInclusionsOpen,
  resortInclusionPopupData,
  shopCurrency,
} from '../actions/main-actions'
import {
  selectedTrip,
  shopInfo,
  selectedCabins,
  guestsSplitting,
  step,
  totalPrice,
  roomParams,
} from '../actions/checkout-la-actions'
import {
  checkoutFilters,
  checkoutInclusions,
  selectedCourseId,
} from '../actions/resort-checkout-actions'
import { selectedShop } from '../actions/bookings-actions'
import { currencyDirective } from '../directives'
import { getLanguage, getTranslations, parseQuery } from 'utils'
import 'babel-polyfill'
import 'whatwg-fetch'

import ErrorHandler from '../components/ErrorHandler'
import '@formatjs/intl-getcanonicallocales/polyfill'
import '@formatjs/intl-locale/polyfill'
import '@formatjs/intl-pluralrules/polyfill'
import '@formatjs/intl-pluralrules/locale-data/en'
import 'finally-polyfill'
import store2 from 'store2'
import moment from 'moment'

import {
  departureDate,
  guestsInRoom,
  fixedPackageDives,
} from '../actions/dive-operator-actions'
import { createRoot } from 'react-dom/client'
import CheckoutLiveaboardPage from '../pages/CheckoutLiveaboardPage'

// import DivesPerNightsRow from '../components/resort/DivesPerNightsRow'

if(process.env.SENTRY_KEY) {
  Sentry.init({
    dsn: process.env.SENTRY_KEY,
    ignoreErrors: [
      'AbortError',
      'UnhandledRejection',
      'Unexpected token o in JSON at position 1',
      'Anonymous function(/gtm.js)',
      "undefined is not an object (evaluating 'd.appendChild')",
      'chrome-extension',
      'gtm',
      'Illegal invocation',
      "Can't find variable: setIOSParameters",
      '(app-modern)',
      'd is undefined',
    ],
  })
}

let store = createStore(
  combineReducers({
    pageLoader,
    selectedCurrency,
    departureDate,
    fixedPackageDives,
    guestsInRoom,
    selectedShop,
    itineraryPopupOpen,
    itineraryPopupData,
    resortInclusionsOpen,
    resortInclusionPopupData,
    checkoutFilters,
    shopCurrency,
    checkoutInclusions,
    selectedCourseId,
    selectedTrip,
    shopInfo,
    selectedCabins,
    guestsSplitting,
    step,
    totalPrice,
    roomParams,
  }),
)

let language = getLanguage()
let messages = {}

window.operatorStore = store
window.store = store
configure(store)

if(language !== 'en') {
  getTranslations(language, renderApp)
} else {
  renderApp()
}

function renderApp(translatedStrings) {
  if(translatedStrings) {
    messages = translatedStrings
  }
  const params = parseQuery()
  if(params.roomParams) {
    try {
      store2('roomParams', JSON.parse(params.roomParams))
    } catch (e) {
      throw new Error('wrong room params', e)
    }
  }
  if(params.dateFrom && params.dateTo) {
    store2('date', [params.dateFrom, params.dateTo])
    store2('departure_date_custom', params.dateFrom)
    store2('duration', moment(params.dateTo).diff(params.dateFrom, 'days'))
  }
  renderElement('checkout-la', CheckoutLiveaboardPage, {
    ...window.shop,
    countryCode: window.countryCode,
  })
  currencyDirective(function(currency) {
    store.dispatch(setCurrency(currency))
  })
}

function renderElement(elem, ComponentToRender, props) {
  let element
  if(typeof elem === 'string') {
    element = document.getElementById(elem)
  } else {
    element = elem
  }

  if(element) {
    const root = createRoot(element)
    root.render(
      <IntlProvider
        locale={language === 'ach' ? 'en' : language}
        messages={messages}
        textComponent='span'
      >
        <Provider store={store}>
          <ErrorHandler>
            <ComponentToRender {...props} />
          </ErrorHandler>
        </Provider>
      </IntlProvider>,
    )
  }
}
